module.exports = __webpack_public_path__ + "img/pc4.5ecd0d11.png";